export default {
    "You can select up to {count} options": "Sie können bis zu {count} Optionen auswählen",
    "Please answer all required questions to continue": "Bitte beantworten Sie alle Pflichtfragen, um fortzufahren",
    "Next Section": "Nächster Abschnitt",
    "Previous Section": "Vorheriger Abschnitt",
    "Next Question": "Nächste Frage",
    "Previous Question": "Vorherige Frage",
    "Complete": "Abschließen",
    "Please enter all field properly": "Bitte füllen Sie alle Felder korrekt aus",
    "This question is required": "Diese Frage ist erforderlich",
    "Choose": "Auswählen",
    "Other option": "Andere Option",
    "Read more": "Mehr lesen",
    "Show less": "Weniger anzeigen",
    "Loading": "Wird geladen",
    "Dashboard": "Dashboard de",
    "Buy more answers": "Buy more 2",
    "Per-location QR codes": "QR-Codes pro Standort",
    "Rooms / Tables / Locations": "Zimmer / Tische / Standorte",
    "Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.": "Erstellen Sie einen QR-Code pro Standort (z. B. Zimmer 101–150 oder Restauranttische). Jeder QR-Code enthält seinen Standort, sodass Antworten automatisch zugeordnet werden — der Gast gibt ihn nie ein. Wählen Sie zuerst oben eine Umfrage und einen Antworttyp.",
    "Add range": "Bereich hinzufügen",
    "Extra locations (comma-separated, e.g. T1, T2, VIP)": "Weitere Standorte (durch Komma getrennt, z. B. T1, T2, VIP)",
    "QR per page": "QR pro Seite",
    "Label prefix (Room / Table / Σημείο)": "Bezeichnungspräfix (Zimmer / Tisch / Standort)",
    "Caption (e.g. SCAN TO ANSWER)": "Beschriftung (z. B. SCAN TO ANSWER)",
    "Sheet title (defaults to survey name)": "Blatttitel (Standard: Umfragename)",
    "Generate QR PDF": "QR-PDF erstellen",
    "locations": "Standorte",
    "Please choose a survey": "Bitte wählen Sie eine Umfrage",
    "No locations defined": "Keine Standorte definiert",
    "Too many locations (max 1000)": "Zu viele Standorte (max. 1000)",
    "Invalid range (from must be <= to)": "Ungültiger Bereich (von muss ≤ bis sein)",
    "PDF generated": "PDF erstellt",
    "QR Code Sheet": "QR-Code-Blatt",
    "Generated": "Erstellt",
    "Location": "Standort",
    "Location (room / table):": "Standort (Zimmer / Tisch):",
    "Exact / list (e.g. 205, 210)": "Genau / Liste (z. B. 205, 210)",
    "Range from": "Bereich von",
    "Range to": "Bereich bis",
    "Guest": "Gast",
    "Location — exact / list (e.g. 205, 210)": "Standort — genau / Liste (z. B. 205, 210)",
    "Location range from": "Standortbereich von",
    "Location range to": "Standortbereich bis",
    "is": "ist",
    "is not": "ist nicht",
    "includes": "enthält",
    "does not include": "enthält nicht",
    "between": "zwischen",
    "contains": "enthält",
    "does not contain": "enthält nicht",
    "on": "am",
    "before": "vor",
    "after": "nach",
    "value": "Wert",
    "min": "Min",
    "max": "Max",
    "If answer": "Wenn die Antwort",
    "go to": "gehe zu",
    "Next question (default)": "Nächste Frage (Standard)",
    "Add rule": "Regel hinzufügen",
    "Otherwise, go to": "Andernfalls gehe zu",
    "Send the respondent to a different question depending on their answer to this question. Rules are checked top to bottom; the first match wins. If nothing matches, the default applies.": "Leiten Sie den Befragten je nach Antwort auf diese Frage zu einer anderen Frage. Regeln werden von oben nach unten geprüft; die erste Übereinstimmung gewinnt. Passt keine, gilt die Standardeinstellung.",
    "Add this question's answer options first to build branching rules.": "Fügen Sie zuerst die Antwortoptionen dieser Frage hinzu, um Verzweigungsregeln zu erstellen.",
    "Logic / Branching": "Logik / Verzweigung",
    "optional": "optional",
    "End of survey": "Ende der Umfrage",
    "A question with branching rules is answered before the survey continues.": "Eine Frage mit Verzweigungsregeln wird beantwortet, bevor die Umfrage fortfährt.",

    // reports — modern Analytical/Summary labels
    "Overall score": "Gesamtbewertung",
    "Responses": "Antworten",
    "Positive": "Positiv",
    "positive": "positiv",
    "No answers": "Keine Antworten",

    // reports — Summary period comparison
    "Period 1": "Zeitraum 1",
    "Period 2": "Zeitraum 2",
    "Compare periods": "Zeiträume vergleichen",
    "set Period 2": "Zeitraum 2 festlegen",

    // reports — Text reports search/sort
    "No respondents match": "Keine Befragten entsprechen",
    "Search by location, name, email or answer text…": "Suche nach Standort, Name, E-Mail oder Antworttext…",
    "Sorted worst score first — the responses that need attention are at the top.": "Sortiert nach schlechtester Bewertung zuerst — die Antworten, die Aufmerksamkeit brauchen, stehen oben.",

    // reports — Excel export
    "Excel export is not available for this report": "Excel-Export ist für diesen Bericht nicht verfügbar",
    "Choose a report type above to begin": "Wählen Sie oben einen Berichtstyp, um zu beginnen",
    "Filters": "Filter",
    "Hide filters": "Filter ausblenden",
    "Show results": "Ergebnisse anzeigen",
    "Print": "Drucken",
    "Answer:": "Antwort:",
    "Choose a report type": "Berichtstyp wählen",
};